import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const faqs = [
  {
    q: "I got a backflow notice from the City of Laredo — what do I do?",
    a: "Call us at 956-942-5496 or submit the quick form above. We'll schedule a test, perform it on-site, and file the results directly with the City before your deadline.",
  },
  {
    q: "How often does a backflow device need to be tested?",
    a: "The City of Laredo requires annual testing on all installed backflow preventers. We track your next due date and send reminders so you never miss a deadline.",
  },
  {
    q: "How long does a backflow test take?",
    a: "A standard test takes 20–30 minutes. If the device fails, we can usually repair and re-test the same day depending on parts availability.",
  },
  {
    q: "Do you handle both residential and commercial?",
    a: "Yes. We test, install, and repair backflow preventers for homes, restaurants, medical offices, warehouses, irrigation systems, and industrial facilities.",
  },
  {
    q: "What does testing cost?",
    a: "Pricing depends on device type and location. Most residential tests start at a flat fee. Use the Request Quote form and we'll send exact pricing fast.",
  },
  {
    q: "Do you serve outside Laredo?",
    a: "Yes — Zapata, Cotulla, Freer, McAllen, and Brownsville are all in our regular service area.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="bg-slate-50 border-y border-slate-200 py-20 lg:py-24" data-testid="faq-section">
      <div className="max-w-5xl mx-auto px-5 lg:px-8">
        <div className="step-num">06 — FAQ</div>
        <h2 className="font-display text-4xl sm:text-5xl font-bold mt-3 tracking-tight">
          Questions, answered.
        </h2>

        <Accordion type="single" collapsible className="mt-10 border-t border-slate-200">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-slate-200"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-display text-left text-lg font-semibold py-5 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
